/**
 * Copyright(c) 2019 Knut Petter Meen, all rights reserved.
 */
package net.scalytica.blaargh.styles

object LinerleSVG {

  val Image =
    """<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
      | width="300.000000pt" height="170.000000pt" viewBox="0 0 300.000000 170.000000"
      | preserveAspectRatio="xMidYMid meet">
      |<metadata>
      |Created by Line Renslebr&aring;ten
      |</metadata>
      |<g transform="translate(0.000000,170.000000) scale(0.050000,-0.050000)"
      |fill="#000000" stroke="none">
      |<path d="M4852 3168 c-213 -51 -303 -132 -431 -386 -90 -179 -136 -225 -272
      |-279 -117 -46 -223 -106 -499 -287 -281 -183 -610 -384 -790 -482 -171 -92
      |-184 -117 -40 -73 39 12 93 24 120 28 28 4 99 25 160 49 135 52 144 52 175 2
      |24 -38 -118 -140 -195 -140 -11 0 -59 -17 -105 -39 -87 -40 -168 -65 -445
      |-141 -88 -24 -188 -56 -223 -72 -75 -33 -107 -36 -107 -7 0 29 -120 -37 -180
      |-99 -73 -77 -383 -198 -1110 -435 -412 -134 -577 -198 -587 -227 -6 -18 5 -23
      |33 -15 29 7 38 3 30 -17 -5 -16 0 -28 12 -28 12 0 22 9 22 20 0 11 22 20 50
      |20 27 0 106 17 175 38 355 109 499 148 640 176 85 16 151 37 146 45 -6 8 34
      |11 87 6 54 -6 115 1 141 14 24 13 94 37 156 53 62 16 122 37 134 46 36 30 186
      |47 200 23 22 -36 62 -24 172 50 64 43 118 66 137 58 18 -7 95 -17 172 -22 77
      |-6 176 -20 220 -32 44 -12 123 -20 176 -17 52 3 106 -3 120 -13 13 -11 67 -35
      |119 -55 52 -19 95 -47 95 -62 0 -38 164 -186 308 -278 377 -241 393 -280 110
      |-280 -177 0 -196 -4 -259 -54 l-69 -54 65 -1 c36 -1 65 7 65 18 0 44 84 44
      |132 -1 46 -44 52 -44 173 -18 159 34 391 31 428 -7 8 -7 32 -13 55 -13 33 1
      |25 11 -33 44 -88 51 -98 83 -20 62 90 -25 158 -15 216 31 30 24 69 43 86 43
      |25 0 23 7 -9 29 -36 25 -56 25 -157 -1 -161 -42 -250 -22 -409 90 -73 51 -154
      |103 -182 116 -56 25 -320 260 -320 284 0 13 83 27 390 67 35 4 41 -8 46 -94 9
      |-140 29 -158 165 -146 62 6 130 20 151 31 79 43 443 136 461 118 34 -34 -21
      |-137 -92 -174 -77 -39 -111 -87 -89 -123 7 -12 31 -2 57 22 25 24 79 45 121
      |49 75 7 77 9 84 95 14 161 143 187 288 60 48 -43 109 -84 134 -92 34 -10 42
      |-24 33 -53 -13 -42 21 -53 37 -12 30 78 -112 274 -199 274 -15 0 -27 8 -27 19
      |0 31 74 44 166 31 66 -10 93 -6 112 18 18 21 45 28 79 20 52 -10 52 -10 13 23
      |-60 49 -535 29 -689 -29 -60 -23 -184 -60 -276 -83 -93 -23 -200 -56 -239 -72
      |-104 -44 -133 -25 -115 77 17 101 47 128 269 237 520 256 772 664 700 1131
      |-34 218 111 528 247 528 15 0 42 17 62 38 20 23 96 53 187 73 262 58 336 132
      |114 113 -94 -8 -129 1 -261 64 -235 113 -394 134 -617 80z m550 -75 c113 -60
      |111 -92 -9 -127 -78 -23 -95 -36 -87 -65 25 -99 -342 -261 -445 -197 -30 18
      |-45 18 -69 -3 -35 -28 -44 -121 -12 -121 11 0 20 -19 20 -42 0 -25 16 -46 40
      |-52 52 -14 50 -30 -11 -104 -55 -65 -51 -102 10 -102 29 0 35 -11 26 -45 -8
      |-37 -6 -40 16 -20 91 85 92 -36 1 -152 -28 -37 -61 -82 -72 -100 -11 -18 -29
      |-46 -39 -63 -27 -40 -31 -80 -10 -80 9 0 38 45 63 100 25 55 53 100 61 100 22
      |0 19 -10 -33 -108 -36 -68 -46 -111 -38 -169 6 -47 2 -83 -12 -92 -33 -20 -27
      |-52 7 -38 52 19 -25 -110 -112 -188 -88 -79 -89 -105 -4 -55 50 30 48 26 -13
      |-29 -76 -69 -484 -284 -441 -232 14 17 23 32 18 32 -91 19 -99 17 -118 -32
      |-10 -29 -19 -80 -19 -115 0 -35 -7 -55 -15 -44 -8 11 -28 20 -45 20 -16 0 -31
      |18 -33 40 -5 69 -31 130 -49 119 -10 -6 -18 -2 -18 10 0 43 -47 19 -119 -63
      |-79 -89 -307 -138 -367 -78 -12 12 -45 22 -73 22 -58 1 -192 44 -216 69 -8 10
      |-3 11 11 2 16 -9 43 0 65 20 26 24 39 27 39 10 0 -14 13 -20 29 -14 15 6 32 0
      |36 -12 19 -56 424 -45 462 13 19 29 25 52 15 52 -11 0 -25 -9 -32 -20 -7 -12
      |-21 -15 -31 -9 -11 6 -19 -3 -19 -20 0 -18 -17 -31 -41 -31 -35 0 -37 6 -17
      |43 19 36 18 41 -9 31 -17 -7 -36 -5 -41 3 -5 8 -102 14 -216 12 -113 -2 -221
      |4 -238 13 -23 11 -44 4 -69 -23 -43 -47 -72 -51 -55 -7 10 28 6 29 -32 5 -36
      |-23 -46 -23 -60 0 -11 17 -33 22 -59 14 -35 -11 -40 -7 -29 23 12 33 10 33
      |-31 -3 -43 -37 -23 -85 24 -57 11 7 13 2 5 -11 -15 -24 -190 -31 -267 -10 -68
      |18 -33 47 56 47 44 0 79 7 79 16 0 9 46 29 102 45 56 15 107 39 112 53 6 14
      |41 31 80 38 49 9 62 18 43 30 -21 14 -19 17 8 18 19 0 35 9 35 20 0 11 -8 20
      |-18 20 -10 0 -13 20 -7 43 10 37 5 41 -27 29 -159 -62 -885 -252 -964 -252
      |-62 0 4 35 110 59 398 89 999 278 1223 385 l87 41 -87 36 c-48 19 -103 40
      |-122 46 -49 16 -43 71 10 92 31 12 51 9 66 -9 23 -29 149 -7 327 58 99 36 118
      |39 91 14 -10 -9 -52 -28 -92 -41 -41 -12 -78 -36 -85 -52 -6 -16 -25 -29 -41
      |-29 -17 0 -31 -10 -31 -22 0 -14 20 -17 55 -8 30 8 76 18 102 23 26 5 101 36
      |167 69 139 70 167 69 60 -2 -41 -27 -99 -69 -131 -94 l-56 -46 52 0 c47 0 105
      |24 160 66 12 9 50 34 86 55 93 55 82 69 -77 99 -80 16 -147 39 -152 54 -16 42
      |6 52 51 23 34 -21 53 -20 113 9 88 42 110 43 110 4 0 -16 17 -30 39 -30 21 0
      |52 14 68 30 17 17 40 30 52 30 11 0 21 -13 21 -30 0 -41 58 -38 106 5 29 26
      |42 28 49 10 12 -34 75 -31 148 6 57 30 60 30 53 -4 -3 -20 -32 -49 -63 -64
      |-73 -35 -52 -56 25 -24 59 25 83 67 119 206 13 49 13 75 0 75 -11 0 -15 8 -9
      |17 37 60 -232 166 -321 125 -28 -13 -56 -20 -60 -16 -9 9 145 134 167 135 68
      |2 176 154 206 291 12 53 32 109 45 124 36 43 338 181 415 190 39 4 84 9 102
      |11 17 2 71 -18 120 -44z m-1360 -856 c133 24 152 14 35 -18 -48 -13 -107 -33
      |-132 -44 -50 -24 -165 -32 -165 -12 0 25 130 90 142 72 7 -11 56 -10 120 2z
      |m-1532 -1068 c-33 -15 -76 -28 -97 -28 -20 -1 -159 -49 -310 -108 -233 -92
      |-431 -153 -402 -125 10 9 424 166 629 238 159 56 287 72 180 23z m899 -211
      |c11 -10 -21 -6 -70 10 -164 53 -239 85 -229 96 13 13 272 -78 299 -106z"/>
      |<path d="M5063 2982 c-40 -25 -20 -80 42 -118 52 -32 57 -31 97 9 79 80 -39
      |173 -139 109z"/>
      |<path d="M4180 1894 c0 -15 -40 -57 -90 -94 -135 -101 -117 -126 50 -68 60 21
      |91 24 96 9 4 -11 22 -21 41 -21 28 1 28 3 4 19 -39 25 20 94 119 138 66 29 67
      |31 21 39 -29 5 -58 -5 -72 -24 -30 -40 -87 -41 -102 -2 -14 37 -67 40 -67 4z"/>
      |<path d="M3630 1722 c-47 -11 -59 -23 -55 -58 4 -36 -6 -44 -50 -45 -90 0
      |-374 -110 -381 -147 -8 -37 107 -48 120 -11 4 12 29 25 56 29 28 5 75 14 105
      |22 48 11 54 8 42 -23 -10 -25 -7 -31 11 -20 16 10 29 0 36 -27 13 -49 25 -52
      |75 -15 49 36 27 102 -29 87 -22 -6 -40 -2 -40 8 0 18 41 27 105 21 19 -1 35 9
      |35 24 0 18 19 23 60 17 47 -7 60 -1 60 26 0 28 6 30 28 11 20 -16 32 -17 42
      |-1 10 15 21 16 39 1 18 -15 46 -13 98 9 89 37 94 53 13 37 -36 -7 -72 -2 -91
      |14 -17 14 -57 24 -89 23 -33 -1 -64 7 -71 17 -12 21 -29 21 -119 1z"/>
      |<path d="M3077 1691 c-19 -20 -481 -131 -499 -120 -10 6 -72 -21 -138 -61
      |-114 -69 -150 -99 -95 -80 14 5 57 13 95 18 200 25 809 252 677 252 -17 0 -35
      |-4 -40 -9z"/>
      |</g>
      |</svg>
      |
    """.stripMargin

}



// WEBPACK FOOTER //
// /Users/kpm/Development/scalytica/renslebraten.no/_project/src/main/scala/net/scalytica/blaargh/styles/LinerleSVG.scala